import gql from 'graphql-tag';

const SITUATION = gql`
  fragment situationDetails on Situation {
    id
    log
    assignedTo
    isSelfProcessed
    generatedAt
    processedAt
    receivedAt
    roundId
  }
`;

// situationDetails without `log`, for lists: the log grows to MBs on
// long-lived situations and lists never show it. The history log modal fetches
// it on open (DeviceHistorySituationLogsModal).
const SITUATION_LIST = gql`
  fragment situationListDetails on Situation {
    id
    assignedTo
    isSelfProcessed
    generatedAt
    processedAt
    receivedAt
    roundId
  }
`;

export default {
  SITUATION,
  SITUATION_LIST,
};
